import { Button, Typography } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';
import { Dispatch, SetStateAction, useState } from 'react';
import { useChatContext } from 'stream-chat-react';
import { useUser } from '../../../../Hooks/useUser';
import { useGetTalentsToMessageQuery } from '../../../../Redux/api/clientApi';
import { useGetClientsToMessageQuery } from '../../../../Redux/api/talentApi';
import { setTalentSearchResult } from '../../../../Redux/slices/TalentSearchSlice';
import { useAppDispatch } from '../../../../Redux/store';
import { KaziModal } from '../../../../Shared Components/Kazi/KaziModal';
import { ProfileType } from '../../../../Types/General';
import ClientComposeContent from './ClientComposeContent';
import TalentComposeContent from './TalentComposeContent';

interface ComposeMessageModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    handleCompose: (prop: string) => void;
}
const ComposeMessageModal = ({ open, setOpen, handleCompose}: ComposeMessageModalProps) => {
    /* ******************** Hooks ******************** */
    const { type, hasPremium } = useUser();
    const dispatch = useAppDispatch();
    const isClient = type === ProfileType.Client;
    const {
        data: hiredTalents,
        isLoading: hiredTalentsLoading
    } = useGetTalentsToMessageQuery(isClient ? undefined : skipToken);
    const {
        data: employers,
        isLoading: employersLoading
    } = useGetClientsToMessageQuery(!isClient ? undefined : skipToken);
    const { setActiveChannel } = useChatContext();
    /* ******************** Variables ******************** */
    const [selectedRecepient, setSelectedRecepient] = useState<any>(undefined);
    const hasNoRecepients = employers && employers.length === 0 || (isClient && !hasPremium && (hiredTalents?.length ?? 0) === 0)
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false);
        dispatch(setTalentSearchResult([]));
    }
    const handleMessage = (selectedRecepient: any) =>{
        handleCompose(selectedRecepient);
        setSelectedRecepient(undefined);
    }
    const getModalContent = () =>{
        if (hasNoRecepients){
            return (
                <Typography variant='body-medium'>You need to be part of an active project in order to send a message.</Typography>
            )
        }
        if (isClient) {
            return (
                <ClientComposeContent 
                    {...{ hiredTalents, selectedRecepient, setSelectedRecepient}}
                />
            )
        }
        return ( 
            <TalentComposeContent 
                {...{ employers, selectedRecepient, setSelectedRecepient }}
            />  
        )
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title={hasNoRecepients ? 'You cannot message anyone' : 'Who do you want to message?'}
            content={getModalContent()}
            actions={[                          
                <Button 
                    variant={'contained'} 
                    onClick={ () => handleMessage(selectedRecepient)} 
                    disabled={selectedRecepient === undefined}
                    sx={{
                        "&.Mui-disabled": {
                            backgroundColor: 'black.50',
                            border: 'none',
                            color: 'primary.main'
                        }
                    }}
                >
                    Message
                </Button>]}
        />
    )
}

export default ComposeMessageModal;